import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../urldata';

const BannerLanding = () => {
    const [searchParams] = useSearchParams();
    const banner = searchParams.get('banner');
    const deviceParam = searchParams.get('device');
    const [status, setStatus] = useState("Redirecting to your destination...");

    useEffect(() => {
        const handleRedirect = async () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let targetStore = deviceParam;

            // If targetStore is not provided in URL, detect from browser
            if (!targetStore) {
                const isIOS = /iPad|iPhone|iPod/.test(userAgent) ||
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

                if (/android/i.test(userAgent)) {
                    targetStore = "android";
                } else if (isIOS || /CriOS/i.test(userAgent)) {
                    // CriOS is Chrome on iOS, though usually caught by iPhone/iPad check
                    targetStore = "ios";
                } else {
                    targetStore = "web";
                }
            }

            // Call API in background
            try {
                if (API_BASE_URL) {
                    const bannerNumber = banner ? parseInt(banner) : 0;
                    // 'loglinkclick' assumed based on previous context, user wrote 'loginlinkclick' which looks like a typo
                    await fetch(`${API_BASE_URL}/tapi/loglinkclick?banner_number=${bannerNumber}&targetStore=${targetStore}&agent=${encodeURIComponent(userAgent)}`);
                }
            } catch (error) {
                console.error("Tracking error", error);
            }

            // Redirect Logic
            if (targetStore === 'android') {
                window.location.href = "https://play.google.com/store/apps/details?id=com.toytrade.exchange";
            } else if (targetStore === 'ios') {
                window.location.href = "https://apps.apple.com/pk/app/toy-trade-pakistan/id6742099837";
            } else {
                // Determine web destination
                // If it is same domain, we can just redirect to home
                //window.location.href = "https://toytrade.pk";
                window.location.href = "https://play.google.com/store/apps/details?id=com.toytrade.exchange";
            }
        };

        handleRedirect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-white">
            <div className="text-center">
                <img
                    src="/images/textlogo.png"
                    alt="ToyTrade"
                    style={{ maxWidth: '200px', marginBottom: '20px' }}
                />
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h4 className="mt-4 text-muted">{status}</h4>
            </div>
        </div>
    );
};

export default BannerLanding;
